export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_USER = "LOGIN_USER";
export const SET_ACTIVE_KEY = "SET_ACTIVE_KEY";
